import React from 'react';
import styled from 'styled-components';
import { string, bool } from 'prop-types';
import Icon from '../Icon';

import { SubBodyText } from '../Text/Heading';
import Wrapper from '../Wrapper';

const SubInfo = styled(SubBodyText)(({ theme }) => ({
  marginRight: 16,
  color: theme.colors.greyDark,
  display: 'inline-block',
}));

const TwoWaysFlightIcon = styled(Wrapper)(({ theme }) => ({
  color: theme.colors.greyDark,
  margin: '0 8px',
  display: 'inline-block',
  verticalAlign: 'middle',
}));

const SummaryWrapper = styled(Wrapper)`
  display: block;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  @media (max-width: 600px) {
    display: flex;
    flex-wrap: wrap;
  }
`;

const InlineTwoWaysFlightIcon = styled(TwoWaysFlightIcon)`
  display: inline-flex;
  align-items: center;
  margin: 0 3px;
`;

const SummaryInlineWrapper = styled(Wrapper)`
  display: inline-flex;
  align-items: center;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 12px;
  line-height: 12px;
`;

const FlightSummaryTitle = ({
  originStation,
  destinationStation,
  isTwoWays = true,
  ...rest
}) => {
  return (
    <SummaryWrapper {...rest}>
      {originStation}
      <TwoWaysFlightIcon>
        {isTwoWays ? (
          <Icon icon="SwapHorizIcon" fontsize="titleSmall" />
        ) : (
          <Icon icon="ArrowRightAltIcon" fontsize="titleSmall" />
        )}
      </TwoWaysFlightIcon>
      {destinationStation}
    </SummaryWrapper>
  );
};

FlightSummaryTitle.propTypes = {
  originStation: string.isRequired,
  destinationStation: string.isRequired,
  isTwoWays: bool,
};

const FlightSummaryInlineTitle = ({
  originStation,
  destinationStation,
  isTwoWays = true,
}) => {
  return (
    <SummaryInlineWrapper>
      {originStation}
      <InlineTwoWaysFlightIcon>
        {isTwoWays ? (
          <Icon icon="SwapHorizIcon" fontsize="titleSmall" />
        ) : (
          <Icon icon="ArrowRightAltIcon" fontsize="titleSmall" />
        )}
      </InlineTwoWaysFlightIcon>
      {destinationStation}
    </SummaryInlineWrapper>
  );
};

FlightSummaryInlineTitle.propTypes = {
  originStation: string.isRequired,
  destinationStation: string.isRequired,
  isTwoWays: bool,
};

const FlightSummarySubTitle = ({ date, guests, rooms }) => {
  return (
    <>
      <SubInfo fontSize={[12, 14]} lineHeight={['16px', '18px']}>
        {date}
      </SubInfo>
      <SubInfo fontSize={[12, 14]} lineHeight={['16px', '18px']}>
        {guests}
      </SubInfo>
      <SubInfo fontSize={[12, 14]} lineHeight={['16px', '18px']}>
        {rooms}
      </SubInfo>
    </>
  );
};

FlightSummarySubTitle.propTypes = {
  date: string.isRequired,
  guests: string.isRequired,
  rooms: string.isRequired,
};

export { FlightSummarySubTitle, FlightSummaryTitle, FlightSummaryInlineTitle };
